import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Box,
    FormControl,
    Input,
    Checkbox,
    FormLabel,
    ModalFooter,
    Button,
    UnorderedList,
    ListItem
} from "@chakra-ui/react";

import { CustomAlert } from "components/alerts/CustomAlert"

import { Select, OptionBase, GroupBase } from "chakra-react-select";

export interface valueOption extends OptionBase {
    label: string;
    value: string;
}

export type DynamicModalFormOptions = {
    for: string;
    options: valueOption[]
}

export type ListedEvent = {
    on: string | 'Change' | 'Blur' | 'Click' | 'Focus' | 'Tab'
    action: (ev: any, ...rest: any[]) => void
}

export type FormRequestError = {
    message: string,
    fieldErrors?: {
        field: string,
        description: string
    }[]
}

export class FormField {
    displayableName: string
    valueName: string
    type: 'text' | 'number' | 'date' | 'password' | 'boolean' | 'option' | 'multi-option' | 'file'
    options?: valueOption[] = []
    defaultValue?: any = null
    readOnly?: boolean = false
    required?: boolean = false
    hidden?: boolean = false
    events?: ListedEvent[] = []
}

export const RequestError = (props: { error: FormRequestError }) => {
    const { error } = props
    return (
        <CustomAlert status="error" message={error.message} marginBottom='20px'>
            {error.fieldErrors?
            <UnorderedList>
                {error.fieldErrors.map((e) => <ListItem key={Math.random()}>{e.field} - {e.description}</ListItem>)}
            </UnorderedList>
            :null}
        </CustomAlert>
    )
}

export const DynamicFieldForm = (props: { fields: FormField[] }) => {

    const { fields } = props

    const eventsToObject = (evs: ListedEvent[]) => {
        let obj: { [x: string]: (ev: any) => void } = {}
        evs.map((ev) => {
            ev.on.replace(' ', '').split(',').map((on) => {
                obj[`on${on}`] = ev.action
            })
        })
        delete obj._
        return obj
    }

    const getFieldComponent = (field: FormField) => {

        let element = null
        let events = field.events ? eventsToObject(field.events) : {}

        if (field.hidden === true) { return <></> }

        if (field.type === 'option') {

            element = (
                <Box mb='10px' key={Math.random()}>
                    <Select<valueOption, true, GroupBase<valueOption>>
                        key={Math.random()}
                        size='sm'
                        options={field.options}
                        maxMenuHeight={160}
                        placeholder={field.displayableName}
                        defaultValue={field.defaultValue}
                        name={field.valueName}
                        required={field.required}
                        {...events}
                    />
                </Box>
            )
        }

        else if (field.type === 'multi-option') {

            element = (
                <Box mb='10px' key={Math.random()}>
                    <Select<valueOption, true, GroupBase<valueOption>>
                        key={Math.random()}
                        size='sm'
                        options={field.options}
                        maxMenuHeight={160}
                        placeholder={field.displayableName}
                        name={field.valueName}
                        required={field.required}
                        defaultValue={field.defaultValue}
                        isMulti
                        {...events}
                    />
                </Box>
            )
        }

        else if (field.type === 'text' || field.type === 'number' || field.type === 'date' || field.type == 'password') {
            element = (
                <Input
                    key={Math.random()}
                    type={field.type}
                    name={field.valueName}
                    placeholder={field.displayableName}
                    defaultValue={field.defaultValue}
                    readOnly={field.readOnly}
                    required={field.required}
                    variant="auth"
                    size='md'
                    fontWeight='200'
                    fontSize='sm'
                    color={field.readOnly ? 'gray.400' : 'white'}
                    mb='10px'
                    {...events}
                />
            )
        }

        else if (field.type === 'boolean') {
            element = (
                <Checkbox
                    key={Math.random()}
                    defaultChecked={field.defaultValue}
                    colorScheme='brandScheme'
                    ms='10px'
                    name={field.valueName}
                    readOnly={field.readOnly}
                    {...events}
                />
            )
        }

        element = (
            <>
                <FormLabel
                    display='flex'
                    ms='4px'
                    fontSize='sm'
                    fontWeight='500'
                    mb='8px'
                    key={Math.random()}
                >
                    {`${field.displayableName}${field.required ? ' *' : ''}`}
                    {field.type === 'boolean' ? element : null}
                </FormLabel>
                {field.type !== 'boolean' ? element : null}
            </>
        )

        return element
    }

    return (<FormControl>{fields.map((f) => getFieldComponent(f))}</FormControl>)

}

export const DynamicFormModal = (props: {
    isOpen: boolean,
    onClose: () => void,
    title: string,
    fields: FormField[]
    buttonText: string,
    buttonOnClick: () => void,
    error?: FormRequestError
    [x: string]: any
}) => {

    const { isOpen, onClose, title, fields, buttonText, buttonOnClick, error } = props

    return (
        <Modal
            isCentered
            isOpen={isOpen}
            onClose={() => {
                onClose();
            }}
        >
            <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
            <ModalContent mx={'10px'} pb={'10px'} w={'35vw'}>
                <ModalHeader>{title}</ModalHeader>
                <ModalCloseButton />
                <ModalBody >
                    {error ? <RequestError error={error} /> : null}
                    <Box maxH='60vh' overflowY='scroll'>
                        <DynamicFieldForm fields={fields} />
                    </Box>
                </ModalBody>
                <ModalFooter py={'5px'}>
                    <Button variant='brand' size="md" type="submit" onClick={() => buttonOnClick()}>{buttonText}</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}